import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  Component,
  computed,
  ElementRef,
  input,
  OnDestroy,
  output,
  signal,
  viewChildren,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { IContentStatusBarItem } from './content-status-bar-graph.interface';

@Component({
  imports: [NgClass, NgxSkeletonLoaderModule, TranslateModule],
  selector: 'app-content-status-bar-graph',
  styleUrl: './content-status-bar-graph.component.scss',
  templateUrl: './content-status-bar-graph.component.html',
})
export class ContentStatusBarGraphComponent implements AfterViewInit, OnDestroy {
  public readonly items = input.required<IContentStatusBarItem[]>();
  public readonly barHeight = input<number>(28);
  public readonly loading = input<boolean>(false);
  public readonly maxWidth = input<number>(268);

  public readonly itemClicked = output<IContentStatusBarItem>();

  public readonly labelWidth = signal<number>(0);

  private readonly labelRefs = viewChildren<ElementRef<HTMLSpanElement>>('labelRef');

  private resizeObserver?: ResizeObserver;

  public readonly maxCount = computed((): number => {
    const counts = this.items().map((item) => item.count);

    return Math.max(...counts, 1);
  });

  public ngAfterViewInit(): void {
    this.measureLabels();
    this.resizeObserver = new ResizeObserver(() => this.measureLabels());
    this.labelRefs().forEach((ref) => this.resizeObserver!.observe(ref.nativeElement));
  }

  public ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  private measureLabels(): void {
    const max = this.labelRefs().reduce((m, ref) => Math.max(m, ref.nativeElement.scrollWidth), 0);

    this.labelWidth.set(max);
  }

  public barWidth(count: number): number {
    const max = this.maxCount();
    const maxPx = this.maxWidth();
    const minPx = 28;

    if (max === 0) {
      return minPx;
    }

    return Math.max((count / max) * maxPx, minPx);
  }
}
